import { render } from "./LandingDemo.vue?vue&type=template&id=f5e39fb6"
import script from "./LandingDemo.vue?vue&type=script&lang=js"
export * from "./LandingDemo.vue?vue&type=script&lang=js"

import "./LandingDemo.vue?vue&type=style&index=0&id=f5e39fb6&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__